<template>
  <div>
    <!-- 背景图 -->
    <div class="top">
      <div class="t-t1">服务流程</div>
      <div class="t-t2box">
        <div class="t-t2">诚信天下 服务至上</div>
      </div>
    </div>

    <!-- 子路由 -->

    <!-- 内容 -->
    <div class="box">
      <!-- 行业选择 -->
      <div class="choice">
        <div class="ch1">服务流程</div>
        <div :class="show == 0 ? 'ch2' : 'ch'" @click="show = 0">咨询流程</div>
        <div :class="show == 1 ? 'ch2' : 'ch'" @click="show = 1">培训流程</div>
        <div :class="show == 2 ? 'ch2' : 'ch'" @click="show = 2">商务流程</div>
      </div>

      <div class="imgs"><img src="@/image/Servicess/liuchengtu.png" alt="" /></div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
export default {
  name: 'ServiceIndex',

  data() {
    return {
      show: 0,
    }
  },

  mounted() {},

  methods: {
    ToXiangqin() {
      router.push('/cases')
      this.show = 0
    },
  },
}
</script>

<style lang="scss" scoped>
// .box {
//   width: 100%;
// }
// 行业选择
.choice {
  margin-left: 120px;
  display: flex;
  margin-bottom: 30px;
  align-items: center;
  .ch1 {
    margin-right: 18px;

    font-size: 20px;
  }
  .ch {
    background-color: #f7f7f7;
    color: #333333;
    font-size: 16px;
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 4px;
    letter-spacing: 1px;
    margin-right: 8px;
  }
  .ch2 {
    background-color: #4581fb;
    color: #fff;
    font-size: 16px;
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 4px;
    letter-spacing: 1px;
    margin-right: 8px;
  }
}

// 行业选择 end--------------
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/zhibo/bj.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

.box {
  width: 1300px;
  // height: 1730px;
  margin: 50px auto;

  // padding-left: 150px;

  // justify-content: space-around;

  .imgs {
    margin: 80px auto;
    width: 630px;
    display: flex;
    justify-content: center;
  }
}
</style>
